import Controller from "../../../../core/js/Controller";

export default class MatchCenter extends Controller {
    afterInit() {
        this.filter = 'all';

        setInterval(() => {
            this.reloadData();
        }, 15000);
    }

    changeTab(e, el) {
        e.preventDefault();

        let tab_name = el.dataset.tab;

        if (tab_name == 'text') {
            this.tab_link_text.addClass('active');
            this.tab_link_video.removeClass('active');

            this.tab_video.addClass('hidden');
            this.tab_text.removeClass('hidden');
        } else {
            this.tab_link_text.removeClass('active');
            this.tab_link_video.addClass('active');

            this.tab_text.addClass('hidden');
            this.tab_video.removeClass('hidden');
        }
    }

    setPlayer(e, el) {
        e.preventDefault();

        if (el.hasClass('active')) {
            return;
        }

        if (document.querySelector('.channels .radio.active').length) {
            document.querySelector('.channels .radio.active').removeClass('active');
        }

        el.addClass('active');

        this.frame.innerHTML = atob(el.dataset.code);
    }

    filterLines(e, el) {
        e.preventDefault();

        if (el.hasClass('active')) {
            return;
        }

        document.querySelector('.filters .radio.active').removeClass('active');
        el.addClass('active');

        this.filter = el.dataset.filter;
        this.applyFilter();
    }

    applyFilter() {
        if (this.filter === 'important') {
            document.querySelectorAll('.stream-text li').forEach((item) => {
                if (!item.hasClass('bold')) {
                    item.addClass('force-hidden');
                }
            });
        } else {
            document.querySelectorAll('.stream-text li').forEach((item) => {
                item.removeClass('force-hidden');
            });
        }
    }

    reloadData() {
        App.getRequest('/api/match-center', {id: this.data.id}).onDone(response => {
            this.lines.innerHTML = response.data.textLines;
            this.score.innerHTML = response.data.score;

            this.applyFilter();
        }).onFail(result => {
            console.log('fail', result);
        }).execute();
    }
}